module.exports = __webpack_public_path__ + "web/img/tab1-bg.abef63fc.png";